<template>
  <div class="electricity-trend-day">
    <div class="title">日用电趋势统计</div>
    <div class="query-condition">
      <div class="condition-row">
        <div class="label">建筑</div>
        <el-select v-model="buildingData" clearable placeholder="请选择" @change="queryData">
          <el-option v-for="item in buildingArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="condition-row">
        <div class="label">日期</div>
        <el-date-picker v-model="dayDate" type="date" value-format="yyyy-MM-dd" :clearable="clearFlag" @change="queryData"
          placeholder="选择日期"></el-date-picker>
      </div>
    </div>
    <div class="chart-box">
      <div class="line-legend">
        <div class="legend-label-first"></div>
        <div class="legend-text">高峰</div>
        <div class="legend-label-third"></div>
        <div class="legend-text">平时</div>
        <div class="legend-label-second"></div>
        <div class="legend-text">低谷</div>
      </div>
      <div id="buildingPowerChart" style="width: 100%; height: 90%"></div>
    </div>
  </div>
</template>

<script>
import { api } from '../api'
import { Dates } from "$utils";
import eCharts from "echarts"
export default {
  name: 'ElectricityTrendDay',
  data() {
    return {
      buildingData: '',
      dayDate: Dates.format(new Date(), "yyyy-MM-dd"),
      buildingArr: [],
      clearFlag: false,
      buildingPowerChart: null,
      buildingPowerChartOpt: null,
      todayConsumption: {}
    }
  },
  created() {
    this.queryBuildList()
    this.queryData()
  },
  mounted() {
    window.onresize = () => {
      this.buildingPowerChart.resize();
    };
  },
  methods: {
    async queryBuildList() {
      const { success, returnObj } = await this.$fetch(api.display.getBuildList)
      if (success) {
        this.buildingArr = returnObj.map(v => {
          return {
            label: v.name,
            value: v.id
          }
        })
      }
    },
    async queryData() {
      const {
        success,
        returnObj
      } = await this.$fetch(api.display.todayConsumption + '?buildId=' + this.buildingData + '&date=' + this.dayDate)
      if (success) {
        this.todayConsumption = returnObj
        this.initBuildingPowerChart();
      }
    },
    initBuildingPowerChart() {
      let chartDom = document.getElementById("buildingPowerChart");
      this.buildingPowerChart = eCharts.init(chartDom);
      const lineColor = ['#59dd98', '#a797f7', '#f68181']
      const arrLength = this.todayConsumption.chartData ? this.todayConsumption.chartData.length : 0
      const pieces = this.todayConsumption.chartData.map((v, index) => {
        return {
          lte: index == arrLength - 1 ? null : index + 1,
          gt: index == 0 ? null : index,
          color: lineColor[v.type],
        }
      })
      this.buildingPowerChartOpt = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '4%',
          right: '5%',
          bottom: '5%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          name: '时',
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }, // X轴底部文字颜色
          axisLabel: {
            interval: 0,//横轴信息全部显示
            rotate: -50,// -20度角倾斜显示
          }, // X轴底部文字倾斜，用于文字过多，有些字不展示的处理
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          }, // X轴网格线的颜色和solid
          data: this.todayConsumption.chartData.map(v => v.dataTime),
        },
        yAxis: {
          name: "单位：kwh",
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          axisPointer: {
            snap: true
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }
        },
        visualMap: {
          show: false,
          dimension: 0,
          pieces: pieces
        },
        series: [
          {
            areaStyle: {},
            name: "用电量",
            type: 'line',
            smooth: true,
            data: this.todayConsumption.chartData.map(v => v.value),
          }
        ]
      };
      this.buildingPowerChart.setOption(this.buildingPowerChartOpt);
    },
  }
}
</script>

<style lang="scss" scoped>
.electricity-trend-day {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title {
    width: 100%;
    height: 38px;
    line-height: 38px;
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    padding: 0 10px;
  }

  .query-condition {
    display: flex;
    justify-content: flex-end;
    margin: 0 10px;

    .condition-row {
      display: flex;
      align-items: center;

      .label {
        margin: 0 15px;
      }
    }
  }

  .chart-box {
    flex: 1;
    margin: 10px 10px 0 10px;

    .line-legend {
      display: flex;
      align-items: center;
      margin: 10px 40px 0 0;
      justify-content: flex-end;

      .legend-label-first {
        width: 25px;
        height: 10px;
        background-color: #f68181;
        margin-left: 10px;
      }

      .legend-label-second {
        width: 25px;
        height: 10px;
        background-color: #59dd98;
        margin-left: 10px;
      }

      .legend-label-third {
        width: 25px;
        height: 10px;
        background-color: #a797f7;
        margin-left: 10px;
      }

      .legend-text {
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>